var _rect, _rect2, _circle, _circle2, _rect3, _rect4, _circle3, _circle4, _rect5, _rect6, _circle5, _circle6, _rect7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevice = function SvgDevice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 80,
    height: 24,
    rx: 6,
    fill: "url(#paint0_linear_2215_12917)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 36,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 36,
    r: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 34,
    width: 19,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 52,
    width: 80,
    height: 24,
    rx: 6,
    fill: "url(#paint1_linear_2215_12917)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 64,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 64,
    r: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 62,
    width: 19,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 80,
    width: 80,
    height: 24,
    rx: 6,
    fill: "url(#paint2_linear_2215_12917)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 92,
    r: 3,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 92,
    r: 3,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 90,
    width: 19,
    height: 4,
    rx: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2215_12917",
    x1: 69.4411,
    y1: 34.8925,
    x2: 72.6384,
    y2: 6.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2215_12917",
    x1: 69.4411,
    y1: 62.8925,
    x2: 72.6384,
    y2: 34.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2215_12917",
    x1: 69.4411,
    y1: 90.8925,
    x2: 72.6384,
    y2: 62.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "device.6dfea20a071e3d3a0c617dfc3d3f8ea5.svg";